import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getYoungWashingtonConfig = (t: TranslateFunction): GiveawayConfig => {
  const squareImage = staticAssetUrl('v1751341114/young-washington/yw-square-img-01.webp')

  return createBaseConfig({
    theatricalSlug: slugs.youngWashington,
    heroTitle: t(
      'giveawayHeroTitleYoungWashington',
      'Pre-Order Tickets to Young Washington and Enter to Win a Classic Ford F-250 Pickup',
    ),
    logoUrl: angelImagesUrl('v1751321459/sketch/Young-Washington-Movie-Wonder.webp'),
    footerLogoUrl: angelImagesUrl('v1751042825/young-washington/yw-logo-white-temp-01.webp'),
    footerBgImage: angelImagesUrl('v1749505430/sketch/dark-pink-bg-01.webp'),
    inTheatersText: t('inTheatersLastYoungWashington', 'In theaters July 4th, 2026'),
    videoImage: angelImagesUrl('v1751504309/young-washington/General_YT_Thumbnail_-_2025-07-01T185215.376.webp'),
    backgroundVideoUrl:
      'https://content.angelstudios.com/young-washington/YW_LoopingVideo_4k_16x9_f23_y20250702_iJH-lowres.mp4',
    share: {
      shareText:
        'The @AngelStudios movie Young Washington is coming to theaters July 4th, 2026. Pre-order tickets for a chance to win a 1970’s Ford F-250 Truck. #YoungWashingtonTruckGiveaway',
      hashtag: '#YoungWashingtonTruckGiveaway',
      shareImage: angelImagesUrl('v1751063350/young-washington/square.webp'),
      shareImageMobile: angelImagesUrl('v1751063350/young-washington/square.webp'),
    },
    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.sketch,
      congratsKey: 'sketchCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Freddie Wong Ultimate Creator Giveaway! Complete your checkout to secure your entries.",
      reservationKey: 'sketchReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Freddie Wong Ultimate Creator Giveaway!",
      noShowtimesKey: 'sketchNowShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the Freddie Wong Ultimate Creator Giveaway.",
      landscapeImage: squareImage,
      portraitImage: squareImage,
    }),

    steps: [
      {
        title: t('preOrderTickets', 'Pre-Order Tickets'),
        description: t(
          'preOrderTicketsStep1DescriptionyoungWashington',
          'Choose from exclusive ticket packs to Young Washington, coming to theaters July 4, 2026.',
        ),
      },
      {
        title: t('preOrderTicketsStep2', 'Get Your Promo Codes'),
        description: t(
          'preOrderTicketsStep2DescriptionyoungWashington',
          'You’ll receive one code per ticket purchased. Redeem your promo codes for actual tickets when showtimes are announced.',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'preOrderTicketsStep3DescriptionYW',
          'Pre-ordering 4 or more tickets gives you bonus entries for the Grand Prize Classic Truck Giveaway. The earlier you pre-order, the more entries you receive!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488884/young-washington/INT.VernonLighting_Comp3.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488885/young-washington/En_Route.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488885/young-washington/Belvoir_Dining-Upres.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488888/young-washington/Follow3.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488893/young-washington/Sc-1.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488895/young-washington/Tree.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488897/young-washington/We_Were_Attacked.webp',
        alt: 'Young Wasington Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1751488898/young-washington/Necessity_Placement4.webp',
        alt: 'Young Wasington Gallery Image',
      },
    ],
    partnerLogos: [],
  })
}
